import {getCheckoutClient} from '../../../config/CheckoutClient';
import { addServerErrors } from '../../../actions/ui';
import { getMemberPayload } from 'checkout/selectors/request';
import { isEmail } from '../../../../helpers/isEmail';

export function setName(name) {
    return {type: "SET_MEMBER_NAME", name};
}

export function setEmail(email) {
    return {type: "SET_MEMBER_EMAIL", email};
}

export function setPhone(phone) {
    return {type: "SET_MEMBER_PHONE", phone};
}

export function setAddress(address) {
    return {type: "SET_MEMBER_ADDRESS", address};
}

export function setSaved(value) {
    return {type: "SET_MEMBER_SAVED", value};
}

export function setEmailOptOut(value) {
    return {type: "SET_MEMBER_EMAIL_OPT_OUT", value};
}

//modify initial state to change the default value
export function setDefaultEmailOptOut(value) {
    return {type: "SET_DEFAULT_MEMBER_EMAIL_OPT_OUT", value};
}

export function setCreatedNewAccount(value) {
    return {type: "SET_MEMBER_CREATED_NEW_ACCOUNT", value};
}

export function setMemberFieldError(field, error) {
    return {
        type: "SET_MEMBER_FIELD_ERROR",
        payload: {
            field,
            error
        }
    }
}

const validateName = (name) => {
    let [, lastName] = name.trim().split(" ").filter(Boolean)

    if (!lastName) {
        return {
            message: 'checkout__invalid_member_name',
        }
    }
}

const validateEmail = (email) => {
    if (!isEmail(email)) {
        return {
            message: 'checkout__invalid_email_pattern'
        }
    }
}

const memberValidators = {
    name: validateName,
    email: validateEmail
}

export function validateMemberField(field) {
    return (dispatch, getState) => {
        const state = getState();

        if (!(field in state.member)) return;

        const value = state.member[field];

        if (!value) {
            dispatch(setMemberFieldError(field, { message: 'checkout__member_required_field' }));
            return;
        }

        const validate = memberValidators[field];

        if (!validate) return;

        const error = validate(value);

        if (error) {
            dispatch(setMemberFieldError(field, error));
            return;
        }

        // Clear error
        dispatch(setMemberFieldError(field, undefined));
    }
}

export function submitMemberInfo() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = getMemberPayload(state);

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'customer', payload, state.reservation.secret).then((result) => {
            dispatch(setSaved(true));
        }).catch((error) => {
            if (error.response.statusCode === 400) {
                dispatch(addServerErrors(error.response.body.errors));
                return Promise.reject("");
            }
        });
    }
}
